import React from 'react';

const CurrentYear = new Date().getFullYear();

const legalLinks = [
  {
    text: 'Privacy',
    href: 'https://www.petsafe.net/privacy/',
  },
  {
    text: 'Wholesalers',
    href: 'https://www.petsafe.net/support/wholesaler-info',
  },
  {
    text: 'Affiliates',
    href: 'https://ascend.pepperjam.com/affiliate/registration.php?refid=141049',
  },
];

function LegalLinks() {
  return (
    <div className="md:pl-4 text-sm text-white inline-block align-bottom mb-12 lg:mb-0">
      ©{CurrentYear}{' '}
      <a
        href="https://petsafebrands.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white"
      >
        PetSafe Brands
      </a>{' '}
      <div className="inline-block">
        All Rights Reserved.{' '}
        {legalLinks.map((link, index) => (
          <React.Fragment key={link.text}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              {link.text}
            </a>
            {index < legalLinks.length - 1 && ' | '}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
export default LegalLinks;
